export {
  default 
} from "./categoryFaqItem";
